// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Theme__Color = require("../../../reason/common/Theme/Theme__Color.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Theme__Color__Vars = require("../../../reason/common/Theme/Theme__Color__Vars.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var ConversationsListItemContext_conversation_graphql = require("../../../__generated__/ConversationsListItemContext_conversation_graphql.bs.js");
var ConversationsListItemContextLocationDisplay_location_graphql = require("../../../__generated__/ConversationsListItemContextLocationDisplay_location_graphql.bs.js");

function ConversationsListItemContext$Details(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: props.top,
                      className: "line-clamp-1"
                    }),
                JsxRuntime.jsx("div", {
                      children: props.bottom,
                      className: "text-sm text-gray-600 line-clamp-1"
                    })
              ],
              className: "flex flex-col"
            });
}

var Details = {
  make: ConversationsListItemContext$Details
};

var convertFragment = ConversationsListItemContextLocationDisplay_location_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationsListItemContextLocationDisplay_location_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationsListItemContextLocationDisplay_location_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationsListItemContextLocationDisplay_location_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationsListItemContextLocationDisplay_location_graphql.node, convertFragment, fRef);
}

var LocationFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationsListItemContext$LocationDisplay(props) {
  var isRental = props.isRental;
  var $$location = use(props.location);
  var tmp;
  switch ($$location.__typename) {
    case "PropertyLocationWithHiddenAddress" :
        var locationDisplay = $$location.locationDisplay;
        tmp = locationDisplay !== undefined ? JsxRuntime.jsx(ConversationsListItemContext$Details, {
                top: locationDisplay,
                bottom: "Hidden Address" + (
                  isRental ? " (Rental)" : ""
                )
              }) : null;
        break;
    case "PropertyLocationWithVisibleAddress" :
        var address = $$location.address;
        if (address !== undefined) {
          var locationDisplay$1 = $$location.locationDisplay;
          tmp = locationDisplay$1 !== undefined ? JsxRuntime.jsx(ConversationsListItemContext$Details, {
                  top: locationDisplay$1,
                  bottom: address + (
                    isRental ? " (Rental)" : ""
                  )
                }) : null;
        } else {
          tmp = null;
        }
        break;
    case "__unselected" :
        tmp = null;
        break;
    
  }
  return JsxRuntime.jsx("div", {
              children: tmp
            });
}

var LocationDisplay = {
  LocationFragment: LocationFragment,
  make: ConversationsListItemContext$LocationDisplay
};

var convertFragment$1 = ConversationsListItemContext_conversation_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationsListItemContext_conversation_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationsListItemContext_conversation_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationsListItemContext_conversation_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(ConversationsListItemContext_conversation_graphql.node, convertFragment$1, fRef);
}

var ConversationFragment_conversationContextTypeV5_decode = ConversationsListItemContext_conversation_graphql.Utils.conversationContextTypeV5_decode;

var ConversationFragment_conversationContextTypeV5_fromString = ConversationsListItemContext_conversation_graphql.Utils.conversationContextTypeV5_fromString;

var ConversationFragment_messageBroadcasStatus_decode = ConversationsListItemContext_conversation_graphql.Utils.messageBroadcasStatus_decode;

var ConversationFragment_messageBroadcasStatus_fromString = ConversationsListItemContext_conversation_graphql.Utils.messageBroadcasStatus_fromString;

var ConversationFragment = {
  conversationContextTypeV5_decode: ConversationFragment_conversationContextTypeV5_decode,
  conversationContextTypeV5_fromString: ConversationFragment_conversationContextTypeV5_fromString,
  messageBroadcasStatus_decode: ConversationFragment_messageBroadcasStatus_decode,
  messageBroadcasStatus_fromString: ConversationFragment_messageBroadcasStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function ConversationsListItemContext(props) {
  var conversation = use$1(props.conversation);
  var match = conversation.conversationContext;
  var tmp;
  if (match !== undefined) {
    switch (match.__typename) {
      case "AvailableConversationContext" :
          var conversationContext = match.context;
          if (conversationContext !== undefined) {
            var tmp$1;
            var exit = 0;
            switch (conversationContext.__typename) {
              case "MessageBroadcast" :
                  tmp$1 = JsxRuntime.jsx(Icon__Jsx3.make, {
                        icon: "Chat",
                        className: "inline align-baseline",
                        size: 32,
                        color: Theme__Color__Vars.astral
                      });
                  break;
              case "BuyerNeedV5" :
              case "RentalNeedV5" :
                  exit = 2;
                  break;
              case "ForSalePropertyV5" :
              case "RentalPropertyV5" :
                  exit = 1;
                  break;
              case "__unselected" :
                  tmp$1 = null;
                  break;
              
            }
            switch (exit) {
              case 1 :
                  var url;
                  switch (conversationContext.__typename) {
                    case "ForSalePropertyV5" :
                        var match$1 = conversationContext.images;
                        if (match$1 !== undefined) {
                          var match$2 = match$1.edges;
                          if (match$2.length !== 1) {
                            url = undefined;
                          } else {
                            var match$3 = match$2[0];
                            url = match$3 !== undefined ? match$3.node.url : undefined;
                          }
                        } else {
                          url = undefined;
                        }
                        break;
                    case "RentalPropertyV5" :
                        var match$4 = conversationContext.images;
                        if (match$4 !== undefined) {
                          var match$5 = match$4.edges;
                          if (match$5.length !== 1) {
                            url = undefined;
                          } else {
                            var match$6 = match$5[0];
                            url = match$6 !== undefined ? match$6.node.url : undefined;
                          }
                        } else {
                          url = undefined;
                        }
                        break;
                    default:
                      url = undefined;
                  }
                  tmp$1 = url !== undefined ? JsxRuntime.jsx("img", {
                          className: "shrink-0 w-9 h-9",
                          src: url
                        }) : JsxRuntime.jsx(Icon__Jsx3.make, {
                          icon: "Home",
                          className: "inline align-baseline",
                          size: 32,
                          color: Theme__Color__Vars.astral
                        });
                  break;
              case 2 :
                  tmp$1 = JsxRuntime.jsx(Icon__Jsx3.make, {
                        icon: "People",
                        className: "inline align-baseline",
                        size: 32,
                        color: Theme__Color__Vars.astral
                      });
                  break;
              
            }
            var tmp$2;
            var exit$1 = 0;
            switch (conversationContext.__typename) {
              case "MessageBroadcast" :
                  tmp$2 = JsxRuntime.jsx(ConversationsListItemContext$Details, {
                        top: conversationContext.category.name,
                        bottom: conversationContext.subject
                      });
                  break;
              case "BuyerNeedV5" :
              case "RentalNeedV5" :
                  exit$1 = 1;
                  break;
              case "ForSalePropertyV5" :
              case "RentalPropertyV5" :
                  exit$1 = 2;
                  break;
              case "__unselected" :
                  tmp$2 = null;
                  break;
              
            }
            switch (exit$1) {
              case 1 :
                  var match$7 = conversationContext.priceRange;
                  var isRental;
                  isRental = conversationContext.__typename === "RentalNeedV5" ? true : false;
                  tmp$2 = JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: Core__Option.getOr(conversationContext.headline, ""),
                                className: "line-clamp-1"
                              }),
                          JsxRuntime.jsx("div", {
                                children: match$7.minPrice.formatted + " - " + match$7.maxPrice.formatted + (
                                  isRental ? "/month" : ""
                                ),
                                className: "text-tan-gold"
                              })
                        ]
                      });
                  break;
              case 2 :
                  var isRental$1;
                  isRental$1 = conversationContext.__typename === "RentalPropertyV5" ? true : false;
                  tmp$2 = JsxRuntime.jsx(ConversationsListItemContext$LocationDisplay, {
                        location: conversationContext.propertyLocation.fragmentRefs,
                        isRental: isRental$1
                      });
                  break;
              
            }
            tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                  children: [
                    JsxRuntime.jsx("div", {
                          children: tmp$1
                        }),
                    tmp$2
                  ]
                });
          } else {
            tmp = null;
          }
          break;
      case "RemovedConversationContext" :
          var tmp$3 = match.entityType;
          if (tmp$3 === "RENTAL_NEED" || tmp$3 === "FOR_SALE_PROPERTY" || tmp$3 === "BUYER_NEED" || tmp$3 === "BROADCAST_MESSAGE" || tmp$3 === "RENTAL_PROPERTY") {
            switch (tmp$3) {
              case "BROADCAST_MESSAGE" :
                  tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                      icon: "Chat",
                                      className: "inline align-baseline",
                                      size: 32,
                                      color: Theme__Color.silverSand
                                    })
                              }),
                          JsxRuntime.jsx("div", {
                                children: "Broadcast message has been removed",
                                className: "text-gray-600"
                              })
                        ]
                      });
                  break;
              case "BUYER_NEED" :
                  tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                      icon: "People",
                                      className: "inline align-baseline",
                                      size: 32,
                                      color: Theme__Color__Vars.silverSand
                                    })
                              }),
                          JsxRuntime.jsx("div", {
                                children: "Buyer need has been removed",
                                className: "text-gray-600"
                              })
                        ]
                      });
                  break;
              case "FOR_SALE_PROPERTY" :
                  tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                      icon: "Home",
                                      className: "inline align-baseline",
                                      size: 32,
                                      color: Theme__Color__Vars.silverSand
                                    })
                              }),
                          JsxRuntime.jsx("div", {
                                children: "Property has been removed",
                                className: "text-gray-600 text-sm"
                              })
                        ]
                      });
                  break;
              case "RENTAL_NEED" :
                  tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                      icon: "People",
                                      className: "inline align-baseline",
                                      size: 32,
                                      color: Theme__Color__Vars.silverSand
                                    })
                              }),
                          JsxRuntime.jsx("div", {
                                children: "Rental need has been removed",
                                className: "text-gray-600"
                              })
                        ]
                      });
                  break;
              case "RENTAL_PROPERTY" :
                  tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                      icon: "Home",
                                      className: "inline align-baseline",
                                      size: 32,
                                      color: Theme__Color__Vars.silverSand
                                    })
                              }),
                          JsxRuntime.jsx("div", {
                                children: "Rental property has been removed",
                                className: "text-gray-600"
                              })
                        ]
                      });
                  break;
              
            }
          } else {
            tmp = null;
          }
          break;
      case "__unselected" :
          tmp = null;
          break;
      
    }
  } else {
    tmp = null;
  }
  return JsxRuntime.jsx("div", {
              children: tmp,
              className: "flex flex-row space-x-2 items-center"
            });
}

var make = ConversationsListItemContext;

exports.Details = Details;
exports.LocationDisplay = LocationDisplay;
exports.ConversationFragment = ConversationFragment;
exports.make = make;
/* Icon__Jsx3 Not a pure module */
